import { styled, Typography } from '../../base-components';
import { shouldForwardProp } from '@mui/system';

const customShouldForwardProp = (prop: PropertyKey) =>
    shouldForwardProp(prop) &&
    !['isMaxCharacterCountReached', 'isPositionAbsolute', 'isError'].includes(
        prop as string
    );

const StyledTypography = styled(Typography, {
    shouldForwardProp: customShouldForwardProp,
})<{
    isMaxCharacterCountReached: boolean;
    isError?: boolean;
}>(({ isMaxCharacterCountReached, isError, theme }) => {
    const shouldRenderError = isError || isMaxCharacterCountReached;
    return {
        color: shouldRenderError
            ? theme.palette.error.main
            : theme.palette.grey[600],
        textAlign: 'end',
        marginTop: theme.spacing(0.25),
        marginInlineEnd: theme.spacing(0.5),
    };
});

export const StyledMaxCharacterCountText = StyledTypography;
